<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('TrendAngleTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: 'line.svg',
                type: 'Angle',
                name: 'Trend Angle',
                hint: 'Draw a Trend Line with angle display',
                data: [],     // Default data
                settings: {}  // Default settings
            }
        }, 'Trend Angle')
</script>
